import { render, staticRenderFns } from "./GuessButton.vue?vue&type=template&id=f120907c&scoped=true&"
import script from "./GuessButton.vue?vue&type=script&lang=js&"
export * from "./GuessButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f120907c",
  null
  
)

export default component.exports